import React from "react";
import "./index.scss";

interface IProps {
  color: string;
  isSubmit: boolean;
  onClick:() => void;
}

export const TimerIcon = ({ color, isSubmit,onClick }: IProps) => {
  return (
    <div className="timer-icon-wrapper">
      {isSubmit ? (
        <div className="timer-selected">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5 2.5C6.97715 2.5 2.5 6.97715 2.5 12.5C2.5 18.0229 6.97715 22.5 12.5 22.5C18.0229 22.5 22.5 18.0229 22.5 12.5C22.5 6.97715 18.0229 2.5 12.5 2.5ZM0 12.5C0 5.59644 5.59644 0 12.5 0C19.4035 0 25 5.59644 25 12.5C25 19.4035 19.4035 25 12.5 25C5.59644 25 0 19.4035 0 12.5ZM12.2855 5.9467C12.9759 5.9467 13.5355 6.50634 13.5355 7.1967V13.4056L17.9441 15.0816C18.5895 15.3269 18.9137 16.0489 18.6684 16.6941C18.4231 17.3395 17.7011 17.6637 17.0559 17.4184L11.8414 15.4362C11.3562 15.2517 11.0355 14.7867 11.0355 14.2677V7.1967C11.0355 6.50634 11.5951 5.9467 12.2855 5.9467Z"
            />
          </svg>
        </div>
      ) : (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
          onClick={onClick}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 2.5C6.97715 2.5 2.5 6.97715 2.5 12.5C2.5 18.0229 6.97715 22.5 12.5 22.5C18.0229 22.5 22.5 18.0229 22.5 12.5C22.5 6.97715 18.0229 2.5 12.5 2.5ZM0 12.5C0 5.59644 5.59644 0 12.5 0C19.4035 0 25 5.59644 25 12.5C25 19.4035 19.4035 25 12.5 25C5.59644 25 0 19.4035 0 12.5ZM12.2855 5.9467C12.9759 5.9467 13.5355 6.50634 13.5355 7.1967V13.4056L17.9441 15.0816C18.5895 15.3269 18.9137 16.0489 18.6684 16.6941C18.4231 17.3395 17.7011 17.6637 17.0559 17.4184L11.8414 15.4362C11.3562 15.2517 11.0355 14.7867 11.0355 14.2677V7.1967C11.0355 6.50634 11.5951 5.9467 12.2855 5.9467Z"
          />
        </svg>
      )}
    </div>
  );
};
